<template>
  <div>
    <el-button
      style="width: 100%; margin-top: 2px; margin-bottom: 25px"
      @click="dialogObject = true"
      size="small"
      type="primary"
    >
      Уведомления
    </el-button>
  <el-dialog
    title="Настройка уведомлений"
    :visible.sync="dialogObject"
  >
    <div style="margin-top: 20px; margin-bottom: 10px; display: flex">
      <el-switch
        v-model="value.enabled"
        active-color="#13ce66"
        inactive-color="#ff4949">
      </el-switch>
      <strong style="margin-left: 10px">Выкл/Вкл уведомления</strong>
    </div>
    <div class="week">
      <div v-for="(t, i) in value.time_shift" class="week--li">
        Смена {{i + 1}}
        <el-time-picker
          value-format="HH:mm"
          size="small"
          style="width: 140px; margin: 0 30px"
          v-model="t.time"
          placeholder="Время">
        </el-time-picker>
        <el-checkbox v-model="t.current_day">Текущий день</el-checkbox>
      </div>
    </div>
    <div class="week">
      <div v-for="(w, i) in week" class="week--li">
        <el-checkbox v-model="value.week[i]">{{w}}</el-checkbox>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button
        type="primary"
        @click="save"
      >Сохранить
      </el-button>
      <el-button @click="dialogObject = false">Закрыть</el-button>
    </div>
  </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Notification",
  props: {
    value: Object
  },
  data() {
    return {
      week: ['Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота', 'Воскресенье'],
      dialogObject: false
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(e) {
        this.$emit('input', e)
      }
    }
  },
  methods: {
    save() {
      this.$emit('save', this.value)
    }
  }
}
</script>

<style lang="scss">
.week {
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  margin-top: 30px;

  &--li {
    padding-bottom: 10px;
    padding-top: 10px;
    border-bottom: 1px solid #eee;
    display: flex;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Users/Notification.vue